// user-dashboard/components/StatusBadgeWithTrafficLight.jsx
import React from 'react';
import InlineStatus from './InlineStatus';
import { PortActivationBadge } from '../../../shared/portActivation';

/**
 * User-dashboard wrapper: canonical activation badge + optional inline messages.
 */
export default function StatusBadgeWithTrafficLight({
  port,
  portStatus,
  portMessages,
  portCountdowns,
  clearPortMessage,
}) {
  const message = portMessages?.[port?.id];
  const countdown = portCountdowns?.[port?.id];

  return (
    <div className="d-flex flex-column gap-1">
      <PortActivationBadge
        statusEntry={portStatus[port?.id] || {}}
        countdown={countdown}
      />
      {message && (
        <InlineStatus
          message={message.message}
          type={message.type}
          countdown={countdown > 0 ? countdown : null}
          onClose={() => clearPortMessage(port.id)}
        />
      )}
    </div>
  );
}
